import { useMutation } from "@tanstack/react-query";
import { IMaterial, IPodcasts } from "../../../core/models/disciplines";
import { IExercise } from '../../../core/models/exercise';
import axiosInstance from "../../../core/api/axios";

type IRelatedInfo = { module: string, subject: string, lesson?: string };

export function useRelatedContentAuxiliar(){
  const { mutate, data, isPending } = useMutation({
    mutationKey: ['get-content-related'],
    mutationFn: ({ module, subject, lesson }: IRelatedInfo) => getRelated(module, subject, lesson),
    retry: false
  })

  return { mutate, data, isPending };
}

// A matéria da aula vai na frente: é ela que aparece no cartão e na rota.
const withSubjectFirst = (exercise: IExercise, subject: string): IExercise => {
  const subjects = exercise.subjects || [];
  const index = subjects.findIndex((it) => it?.slug === subject);
  if (index <= 0) return exercise;
  return { ...exercise, subjects: [subjects[index], ...subjects.filter((_, i) => i !== index)] };
};

// Exercícios cuja resolução é esta videoaula (pelo Vimeo ID ou pelo AWS ID).
// Falha aqui não derruba a aba: ficam só os da matéria.
const getLinkedExercises = async (lesson?: string): Promise<IExercise[]> => {
  if (!lesson) return [];
  try {
    const { data } = await axiosInstance.get(`/lessons/${lesson}/linked-exercises`);
    // Sem matéria o cartão não tem rota (assunto/:slug/exercicio).
    return (data?.exercises || []).filter((it: IExercise) => it?.subjects?.[0]?.slug);
  } catch (e) {
    return [];
  }
};

const getRelated = async (module: string, subject: string, lesson?: string) => {
  try {
    //const { data: { lessons } } = await axiosInstance.get(`/subareas/${module}/lessons`);
    // A matéria filtra no servidor: a 1ª página do módulo inteiro (20 questões
    // por % de acerto) quase nunca trazia as da matéria da aula.
    const { data: { exercises } } = await axiosInstance.post(`/subareas/${module}/exercises`, {
      page: 1,
      pageSize: 2,
      subject: [subject],
    });
    
    const linkedExercises = await getLinkedExercises(lesson);
    const { data: { workbooks } } = await axiosInstance.get(`/subareas/${module}/workbooks`);
    const { data: { podcasts } } = await axiosInstance.get(`/subareas/${module}/podcasts`);

    //const relatedLessons = lessons.filter((it: ILesson) => it.subjects[0].slug === subject);
    // Se o slug da matéria não existir, o servidor ignora o filtro: a conferência fica aqui.
    const subjectExercises = exercises.filter((it: IExercise) =>
      it.subjects?.some((s) => s?.slug === subject)
    );
    const seen = new Set<string>();
    const relatedExercises = [...linkedExercises, ...subjectExercises]
      .filter((it: IExercise) => {
        const key = String(it.id);
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .map((it: IExercise) => withSubjectFirst(it, subject));
    const relatedWorkbooks = workbooks.filter((it: IMaterial) => it.subjects[0].slug === subject);
    const relatedPodcasts = podcasts.filter((it: IPodcasts) => it.subjects[0].slug === subject);

    return { 
      //lesson: relatedLessons.slice(0, 2), 
      exercise: relatedExercises, 
      workbooks: relatedWorkbooks.slice(0,2),
      podcast: relatedPodcasts.slice(0,2)
    }
  } catch(e: any) {
    throw new Error(e);
  }
}